import React, { useEffect } from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import Layout from '../../components/layout';
import SEO from '../../components/seo';
import { SettingProvider } from '../../lib/context/settings';
import { AdsProvider } from '../../lib/context/ads';
import { Button, Col, Row } from 'antd';
import { SecondaryTitle, Title } from '../../components/styles';
import { device } from '../../lib/theme';
import styled from 'styled-components';

const HeroContainer = styled(Row)`
  background-image: url('https://aaacdndev.blob.core.windows.net/wordpress/2020/04/employmentheader.jpg');
  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;
  height: 400px;
  margin: auto;
  h1 {
    max-width: 80%;
    font-size: 32px;
    line-height: 1.1;
  }

  @media ${device.laptop} {
    h1 {
      max-width: 60%;
      font-size: 56px;
      line-height: 1.2;
    }

    background-position: center center;
  }
`;

const client = new ApolloClient<any>({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
  fetchOptions: {
    credentials: 'include',
  },
});

const CareerAssistLP: React.FC<any> = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.location.replace(
        `https://member.acg.aaa.com/car/membership/career-assist.html`
      );
    }
  }, []);

  if (typeof window !== 'undefined') {
    return <></>;
  } else
    return (
      <ApolloProvider client={client as any}>
        <SettingProvider>
          <AdsProvider>
            <Layout key={`${typeof window}`}>
              <SEO
                title="Career Assistance | AAA"
                description="With help from AAA, you can be on the road to the best job or career you’ve ever had! Career assistance is a free service with your AAA Membership."
                canonicalUrl="/membership/career-assistance/"
              />

              <HeroContainer align="middle" justify="center">
                <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 0 }}>
                  <Title>CAREER ASSISTANCE FROM AAA</Title>
                  <h2>Free help for members on the road to employment.</h2>
                </Col>
              </HeroContainer>

              <Row style={{ paddingTop: 48, marginBottom: 48 }}>
                <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                  <Row>
                    <Col xs={{ span: 24 }} md={{ span: 14 }}>
                      <SecondaryTitle>
                        Take advantage of this FREE AAA Member Benefit to
                        supercharge your employment search.
                      </SecondaryTitle>
                      <p>
                        With help from AAA, and partner Intoo &mdash; you may be
                        on the road to the best job or career you&rsquo;ve ever
                        had!
                      </p>
                      <p style={{ color: '#ED1B2E' }}>
                        {' '}
                        <b>
                          AAA provides you with support in six key areas to help
                          you find &mdash; and land &mdash; your next job.
                        </b>
                      </p>
                      <p>
                        <b>Transition Help:</b> Information and assistance to
                        help the unemployed get back on track and plan a future
                        direction. Career assessments may reveal exciting new
                        opportunities.
                      </p>
                      <p>
                        <b>Huge Job Base:</b> Sophisticated job-matching
                        technology with access to millions of open jobs.
                        Targeted job matches can be sent directly to your email
                        or mobile phone.
                      </p>
                      <p>
                        <b>Resume Builder:</b> A fast, easy and effective tool
                        to help you create your most impactful resume.
                      </p>
                      <p>
                        <b>Perfect Pitch:</b> Interesting exercises and
                        workshops help you create a cover letter, elevator pitch
                        or a personal reference sheet to catch employers&apos;
                        attention.
                      </p>
                      <p>
                        <b>Networking:</b> Find contacts within companies,
                        associations and recruiters. Identify connections at
                        target employers in Facebook or LinkedIn.
                      </p>
                      <p>
                        <b>Interview &amp; Follow-Up:</b> Overcome nervousness
                        with virtual video practice interviews and recorded
                        responses. Get tips on thank-you letters, negotiating
                        tactics and more. Intoo is a leader in career placement
                        and career coaching that aims to provide one-on-one
                        support for candidates so they can find and land their
                        dream job.
                      </p>
                      <p style={{ color: '#ED1B2E' }}>
                        <b>
                          Your dream career may be open and waiting for you
                          right now.
                          What&nbsp;are&nbsp;you&nbsp;waiting&nbsp;for?
                        </b>
                      </p>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 9, offset: 1 }}>
                      <div
                        style={{
                          display: 'block',
                          backgroundColor: 'lightgrey',
                          padding: '16px',
                          textAlign: 'center',
                          paddingTop: '24px',
                          paddingBottom: '24px',
                        }}
                      >
                        <h2>
                          <strong>
                            Find&nbsp;a&nbsp;better job&nbsp;with help from AAA.
                          </strong>
                        </h2>
                        <Button
                          type="primary"
                          // href="https://members.carolinas.aaa.com/LoginPageDROuth?redirect_url=https%3A%2F%2Faaacarolinas.yournextstep.com%2Fusers%2Fsign_up%3Fdirect%3DJFibUEkIMRCWfLZ0"
                          href="https://aaacarolinas.yournextstep.com/users/sign_up?direct=JFibUEkIMRCWfLZ0"
                        >
                          Get Started
                        </Button>

                        <p style={{ marginTop: 16 }}>
                          Already registered?{' '}
                          <a href="https://aaacarolinas.yournextstep.com/login">
                            Log in here.{' '}
                          </a>
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Layout>
          </AdsProvider>
        </SettingProvider>
      </ApolloProvider>
    );
};

export default CareerAssistLP;
